import merge from 'lodash/merge';
import { Dictionary } from 'lodash';
import { ReduxEntity } from 'Douleutaras/types';

interface DeepMergeMetaDataArgs {
  state: object;
  action: object;
  metaEndpoint: string;
  mergeOnTop?: boolean; // Merge the given data on top of the meta.data object. By default its appended to the end
}

// Will merge meta data pagination, in order to do scroll / infinite pagination. Works with v2 api
// This is used in a reducer
export const infinitePaginationMergeMeta = (action, state) => {
  if (action.payload.meta[action.payload.endpoint].meta.pagination.page > state.meta?.[action.payload.endpoint]?.meta.pagination.page) {
    // @ts-ignore
    state = deepMergeMetaData(state, action, action.payload.endpoint);
  } else {
    state.meta[action.payload.endpoint] = action.payload.meta[action.payload.endpoint];
  }
};

/**
 * Helper method to deep merge "state.meta.data" items. Useful for pagination
 */
export const deepMergeMetaData = <T>(state, action, metaEndpoint, mergeOnTop = false): ReduxEntity<T> => {
  if (state.meta?.[metaEndpoint] === undefined) {
    state.meta[metaEndpoint] = generateMetaObj();
  }

  const newCurrentPage = action.payload.meta[metaEndpoint].meta?.pagination?.page;
  const currentPage = state.meta[metaEndpoint].meta?.pagination?.page;
  const nextPageLoaded =  newCurrentPage > currentPage;
  const previousPageLoaded =  newCurrentPage < currentPage;

  // For top insertion, reverse first because repeated unshift would otherwise invert message order.
  const iterableData = (previousPageLoaded || mergeOnTop) ?
    action.payload.meta[metaEndpoint].data.slice(0)
      .reverse() : action.payload.meta[metaEndpoint].data;
  // Check if an identical entry exists. If not, add it to data array (do not add duplicates)
  iterableData.forEach(data => {
    const identicalEntry = state.meta[metaEndpoint].data.find(d => d.id === data.id);

    if (!identicalEntry) {
      // Either merge on top, insert on top if previous page of the dataset is loaded.
      if (mergeOnTop || previousPageLoaded) {
        state.meta[metaEndpoint].data.unshift(data);
      } else {
        state.meta[metaEndpoint].data.push(data);
      }
    }
  });
  state.meta[metaEndpoint].links = merge(state.meta[metaEndpoint].links, action.payload.meta[metaEndpoint].links);
  state.meta[metaEndpoint].meta = merge(state.meta[metaEndpoint].meta, action.payload.meta[metaEndpoint].meta);

  return state;
};

export const generateMetaObj = (data = [], links = {}, meta = {}): {
  // tslint:disable-next-line:no-any
  data: Array<any>;
  links: Dictionary<string>;
  meta: {
    pagination: Dictionary<number>
  }
} => {
  return {
    data,
    links,
    meta: {
      pagination: {},
      ...meta
    }
  };
};
